<div class="flip-container">
  <form class="flip-toggle">
    <input type="radio" id="default" name="choice" value="default" [(ngModel)]="displayMode"  (ngModelChange)="onDisplayModeChange($event)">
    <label for="default">Default</label>

    <input type="radio" id="dataPoints" name="choice" value="dataPoints" [(ngModel)]="displayMode" (ngModelChange)="onDisplayModeChange($event)">
    <label for="dataPoints">Data points</label>
  </form>
</div>
